import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  margin-block-start: ${spacing(2)};
`
